// src/components/About.js
import React from "react";

const About = () => {

  return (

    <section className="mb-3" id="about">

      <h2 className="section-title">
        <i className="fas fa-user"></i><span>About Me</span>
      </h2>

      {/* <h2 className="section-title">
        <i className="fas fa-user"></i> <span style={{ marginLeft: "10px" }}>About Me</span>
      </h2> */}

      <p>
        I consider myself a dedicated Product Engineer with a strong QA background, focused on building software that brings real value to users.
      </p>

      <p>
        My experience in QA taught me that quality starts long before testing. Now I bring that mindset into product work: understanding user problems, shaping requirements, and delivering solutions from idea to release.
      </p>

      <p>
        I'm passionate about AI and automation, and I enjoy building tools that remove manual work and help teams move faster.
      </p>

      <p>
        I've worked with teams at Neunen IT, Deloitte, and Doctoranytime, always combining technical skills with strong team spirit.
      </p>

      <p>
        Core areas: Product Engineering · Test Automation · AI Agents & LLMs · QA Leadership
      </p>

    </section>

  );

};

export default About;